import ErrorBase, { ErrorSeverity } from './ErrorBase';
export default class InitializationError extends ErrorBase {
    constructor(loggingDetails = {}) {
        super('Component not initialized correctly', loggingDetails, ErrorSeverity.WARNING);
        this.name = 'InitializationError';
    }
}
